import { render } from "./layout2.vue?vue&type=template&id=492b3f2e&scoped=true"
import script from "./layout2.vue?vue&type=script&lang=js"
export * from "./layout2.vue?vue&type=script&lang=js"

import "./layout2.vue?vue&type=style&index=0&id=492b3f2e&lang=scss&scoped=true"
import "./layout2.vue?vue&type=style&index=1&id=492b3f2e&lang=scss"
import "./layout2.vue?vue&type=style&index=2&id=492b3f2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492b3f2e"]])

export default __exports__